import React, {Component} from 'react';

class Home extends Component {

render(){
    return (
        <div className="home">
            <p className="main-heading"><b>Thabiso Zwane</b></p>
            <p className="main-descr">Full Stack Developer | Desktop Coder | Electronics Technician</p>
            <ul className="socials">
                <li><a href="https://www.facebook.com/zwanets"><i className="fa fa-facebook-square" aria-hidden="true"></i></a></li>
                <li><a href="https://www.linkedin.com/in/thabiso-zwane-29656745/"><i className="fa fa-linkedin-square" aria-hidden="true"></i></a></li>
                <li><a href="https://github.com/TSZwane"><i className="fa fa-github-square" aria-hidden="true"></i></a></li>
            </ul>
        </div>
    )
}

}

export default Home;